module.exports = __webpack_public_path__ + "media/images/icon_list/arrow_down-6d2900a85fc7cb3b19a5b4d375cd89ef.svg";